module.exports = __webpack_public_path__ + "static/media/headspace.2e078a5b.svg";